module.exports = __webpack_public_path__ + "img/82.875e366a.jpg";